import * as Yup from 'yup';
export const initialProvinceValues = {
    description: '',
    enumId: '',
};
export const provinceSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=province.js.map